import Scene from "@scene";

export const SET_CLADDING_TYPE = 'SET_CLADDING_TYPE';

export const SET_CLADDING_OPTIONS = 'SET_CLADDING_OPTIONS';
export const SET_CLADDING_STATE = 'SET_CLADDING_STATE';
export const RESET_CLADDING = 'RESET_CLADDING';


/*
  Action creators
*/
export function setCladdingType(value) {
	return (dispatch) => {
		dispatch(triggerUpdate({ type: SET_CLADDING_TYPE, value }));
	};
}

export function setCladdingOptions(options) {
	return (dispatch) => {
		dispatch(triggerUpdate({ type: SET_CLADDING_OPTIONS, options }));
	};
}

export function setCladdingState(state) {
	return (dispatch) => {
		dispatch(triggerUpdate({ type: SET_CLADDING_STATE, state }));
	};
}
export function resetCladding(){
	return (dispatch) => {
		dispatch(triggerUpdate({ type: RESET_CLADDING }));
	};
}
function triggerUpdate(event) {
	return (dispatch, getState) => {
		dispatch(event);

		Scene.updateCladding(getState().options.cladding);
	};
}



// WEBPACK FOOTER //
// ./src/reducers/options/cladding/actions.js